<template>

    <!-- uncomment click functionality after renewals...
    <v-flex xs12 class="events_banner" @click="openBannerVideo($event)"> -->
    <v-flex xs12 :class="renewalBannerStyle" class="events_banner">
        <v-layout
                justify-space-between
                column
                wrap
                v-if="renewalStatus.showBanner">
            <v-flex v-if="renewalStatus.renewalsStarted"
                    class="renewals_title renewals_title--default">
              <span>{{ renewalConstants.RENEW_NOW_TITLE1 }}</span>
            </v-flex>
          <v-layout v-if="renewalStatus.renewalsStarted" class="renewal-button-span" row wrap>
            <span class="renewals_subtitle renewals_subtitle--default" >
              {{ renewalConstants.RENEW_NOW_SUBTITLE }}
            </span>
            <v-btn id="renew_now_renewals_btn"
                   :class="renewalBannerButtonStyle"
                   class="renewals_button--start"
                   data-qe-id="home-page_forward-to-renewal_link"
                   @click="forwardToRenewal" >
              {{ renewalConstants.START_RENEWAL_BTN }}
            </v-btn>
          </v-layout>
            <v-flex v-if="renewalStatus.showContinue"
                    class="renewals_title renewals_title--default">
              <span>{{ renewalConstants.CONTINUE_TITLE2 }}</span>
            </v-flex>
          <v-layout v-if="renewalStatus.showContinue" class="renewal-button-span" row wrap>
            <span class="renewals_subtitle renewals_subtitle--continue">
              {{ renewalConstants.CONTINUE_SUBTITLE }}
            </span>
            <v-btn id="continue_renewals_btn"
                   class="renewals_button--continue"
                   :class="renewalBannerButtonStyle"
                   data-qe-id="home-page_forward-to-renewal_link"
                   @click="forwardToRenewal" >
              {{ renewalConstants.CONTINUE }}
            </v-btn>
          </v-layout>
          <v-flex v-if="renewalStatus.showInvoices"
                    class="renewals_title renewals_title--invoice">
            <span>{{ renewalConstants.VIEW_INVOICE_TITLE2 }}</span>
           </v-flex>
          <v-layout v-if="renewalStatus.showInvoices" class="renewal-button-span" row wrap>
            <span class="renewals_subtitle renewals_subtitle--invoice">
              {{ renewalConstants.VIEW_INVOICE_SUBTITLE }}
            </span>
            <v-btn  id="invoice_renewals_btn"
                    class="renewals_button--invoice"
                    :class="renewalBannerButtonStyle"
                    data-qe-id="home-page_show-invoice_link"
                    @click="forwardToRenewal" >
              {{ renewalConstants.SHOW_INVOICE }}
            </v-btn>
          </v-layout>
        </v-layout>
    </v-flex>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { storeGetters } from "@/store/storeGetters.constant";
    import { storeAction } from "@/store/storeActions.constant";
    import { renewalConstants } from "../MyAccount/myaccount.constants.js";


    export default {
        name: 'HomeBanner',
        data: () => ({
            renewalConstants,
        }),
        created() {
            if (!this.currentUserId) {
                this.getCurrentUserId().then(() => {
                    this.getRenewalStatus(this.currentUserId);
                });
            } else {
                this.getRenewalStatus(this.currentUserId);
            }
        },
        methods: {
            ...mapActions({
                getRenewalStatus: `myAccount/${storeAction.getRenewalStatus}`,
                getCurrentUserId: `memberProfile/${storeGetters.getCurrentUserId}`,
            }),
            forwardToRenewal() {
                const url = `${this.paymentRedirectUrl}/s/`;
                window.open(url, '_blank');
            },
            openBannerVideo($event) {
                if ($event && $event.target && $event.target.offsetParent && $event.target.offsetParent.id === "" && $event.target.id === "") {
                    window.open('https://videos.ypo.org/youll-never-walk-alone-march-20201', '_blank');
                }
            },
        },
        computed: {
            ...mapGetters({
                renewalStatus: `myAccount/${storeGetters.renewalStatus}`,
                salesforceURLRoot: `${storeGetters.salesforceURLRoot}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                paymentRedirectUrl: `${storeGetters.paymentRedirectUrl}`,
            }),
          renewalBannerStyle() {
              let banner = '';
              if (this.renewalStatus && this.renewalStatus.showBanner) {
                if (this.renewalStatus.renewalsStarted) {
                  banner = 'renewals_show_banner';
                } else if (this.renewalStatus.showContinue) {
                  banner = 'renewals_continue_banner';
                } else if (this.renewalStatus.showInvoices) {
                  banner = 'renewals_invoice_banner';
                } else {
                  banner = '';
                }
              }
              return banner || 'home_banner';
          },
          renewalBannerButtonStyle() {
            let bannerButton = '';
            if (this.renewalStatus && this.renewalStatus.showBanner) {
              if (this.renewalStatus.renewalsStarted) {
                bannerButton = 'renewals_show_banner_button';
              } else if (this.renewalStatus.showContinue) {
                bannerButton = 'renewals_continue_banner_button';
              } else if (this.renewalStatus.showInvoices) {
                bannerButton = 'renewals_invoice_banner_button';
              } else {
                bannerButton = '';
              }
            }
            return bannerButton || 'renewals_default_banner_button';
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';
    @import '../../common/styles/font';

    .events_banner {
        position: relative;
        min-height: 150px;
        margin-top: 64px;
        padding-left:48px;
        padding-top:8px;
        //cursor: pointer;

        @include breakpoint(xs) {
            margin-top: 99px;
            padding-left: 16px;
            padding-top:16px;
        }


        &:before {
            content: '';
            background: rgba($ypo_blue, 0.0);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }

        .renewal-button-span{
          margin-bottom: 16px;
            @include breakpoint(xs) {
                padding-top: 16px;
                padding-left: 32px;
            }
        }

        .renewals_button {
            border-radius: 0;
            color: $white;
            font-size: 12pt;
            font-weight: bold;
            line-height: 18px;
            text-align: center;
            box-shadow: none;
            font-family: 'PPAgrandir', Arial, Helvetica, sans-serif;
            margin-left: 200px;
            margin-top: 16px;
            text-transform: uppercase;
            padding: 20px;

            @include breakpoint(xs) {
                height: 36px;
            }

            @include breakpoint(sm) {
                margin-bottom: 15px;
            }
        }
        .renewals_button--start {
            color: #cbefb8;  
            margin-left: 108px; 
            margin-top: 10px;  
            font-family: 'PPAgrandir', Arial, Helvetica, sans-serif;  

            @include breakpoint(md) {
                margin-left: 65px;
            }
            @include breakpoint(sm) {
                margin-left: 35px;
            }
        }

        .renewals_button--continue {
            color: #faff71;  
            margin-top: 18px; 
            margin-left: 110px; 
            font-family: 'PPAgrandir', Arial, Helvetica, sans-serif;  

            @include breakpoint(sm) {
                margin-left: 80px;
            }
        }

        .renewals_button--invoice {
            color: #ffbecc;  
            margin-top: 18px; 
            margin-left: 108px;
            font-family: 'PPAgrandir', Arial, Helvetica, sans-serif;   
            
            @include breakpoint(sm) {
                margin-left: 80px;
            } 
        }

        .renewals_title {
            color: $ypo-banner-text-color;
            font-family:  'PPAgrandir', Arial, Helvetica, sans-serif;
            font-size: 30pt;
            line-height: 40px;
            font-weight: bold;
            margin: 35px 0px 5px 0;

            @include breakpoint(sm) {
                font-size: 21pt;
                width: 590px;
                line-height: 28px;
            }

            span {
              display: flex;
            }

            &--default {
              width: 890px;
          }

            &--invoice {
              width: 1034px;
          }
        }

        .renewals_subtitle {
          color: $ypo-banner-text-color;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 16pt;
          line-height: 24px;
          font-weight: 600;

            @include breakpoint(xs) {
              width: 302px;
          }

          &--invoice {
              width: 754px;

              @include breakpoint(sm) {
                width: 429px;
            }
          }

          &--continue {
              width: 784px;
              line-height: 22px;

              @include breakpoint(sm) {
                width: 428px;
            }
          }

          &--default {
              width: 552px;

            @include breakpoint(sm) {
                width: 298px;
            }
          }
      }

    }
    .renewals_show_banner {
      background-size: cover !important;
      min-height: 200px;
      background: url(../../assets/ypo-renewals-stage-1.png) no-repeat;
    }

    .renewals_continue_banner {
      background-size: cover !important;
      background: url(../../assets/ypo-renewals-stage-2.png) no-repeat;
    }

    .renewals_invoice_banner {
      background-size: cover !important;
      background: url(../../assets/ypo-renewals-stage-3.png) no-repeat;
    }

    .renewals_show_banner_button {
      background-color: $ypo-banner-text-color !important;
    }

    .renewals_continue_banner_button {
      background-color: $ypo-banner-text-color !important;
    }

    .renewals_invoice_banner_button {
      background-color: $ypo-banner-text-color !important;
    }
    
    .renewals_default_banner_button {
      background-color: $ypo-affair-purple !important;
    }

    .home_banner{
      //uncomment never walk alone banner after renewals...
      //background: url(../../assets/connect-banner-new.jpg);
      background-size: auto;
      background: url(../../assets/connect-renewals-banner-new.png) repeat-x center;
    }
</style>
